
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkProjectShareDossierEntryDto } from '../models/work-project-share-dossier-entry-dto';

export function getCreateProjectShareDtoFormGroup() {
return new FormGroup({
    title: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(200)]),
    validFrom: new FormControl<string | undefined>('', [Validators.required]),
    validUntil: new FormControl<string | undefined>('', [Validators.required]),
    dossierSelection: new FormControl<WorkProjectShareDossierEntryDto[]>([]),
    excludedTaskIds: new FormControl<Array<number> | undefined>([]),
    includedTaskIds: new FormControl<Array<number> | undefined>([]),
    contactIds: new FormControl<Array<number> | undefined>([]),
})
;
}
      